import axios from 'axios'
import {
  OrgExpenseReport,
  OrgExpenseReportCycle,
  OrgExpenseReportMetrics,
} from 'src/models/orgExpenseReports.models'
import { getResponseData } from 'src/queries/network.utils'
import { getRequestConfig, RequestConfig } from 'src/queries/requestConfig'

export const getOrgExpenseReportCycles = async (): Promise<{
  cycles: OrgExpenseReportCycle[]
}> => {
  return getResponseData(
    axios.get<{ cycles: OrgExpenseReportCycle[] }>(
      '/orgexpensereports/cycles',
      getRequestConfig(RequestConfig.Default),
    ),
  )
}

export const getOrgExpenseReportCycle = async (
  cycleId: string,
): Promise<{ cycle: OrgExpenseReportCycle }> => {
  return getResponseData(
    axios.get<{ cycle: OrgExpenseReportCycle }>(
      `/orgexpensereports/cycles/${cycleId}`,
      getRequestConfig(RequestConfig.Default),
    ),
  )
}

export const getOrgExpenseReport = async (
  reportId: string,
): Promise<{ report: OrgExpenseReport }> => {
  return getResponseData(
    axios.get<{ report: OrgExpenseReport }>(
      `/orgexpensereports/${reportId}`,
      getRequestConfig(RequestConfig.Default),
    ),
  )
}

export const getOrgExpenseReportMetrics = async (
  reportId: string,
): Promise<OrgExpenseReportMetrics> => {
  return getResponseData(
    axios.get<OrgExpenseReportMetrics>(
      `/orgexpensereports/${reportId}/metrics`,
      getRequestConfig(RequestConfig.Default),
    ),
  )
}
